import { useGlobalStore } from "@/stores/globalStore";

const useTheme = () => {
  /**
   * Adds/removes 'lightmode' class to the root html element
   * depending on boolean value light theme in pinia store.
   */
  const updateThemeFromStore = () => {
    const store = useGlobalStore();
    const useLightTheme = store.global.theme === "LIGHT";
    updateTheme(useLightTheme);
    if (store.global?.merchant?.theme) {
      updateColor(store.global.merchant?.theme, store.getIsGreyLabel);
    }
  };

  const updateTheme = (useLightTheme) => {
    const rootEl = document.documentElement;
    const rootUsingLightTheme = rootEl.classList.contains("lightmode");

    if (useLightTheme) {
      if (!rootUsingLightTheme) {
        rootEl.classList.add("lightmode");
      }
    } else if (rootUsingLightTheme) {
      rootEl.classList.remove("lightmode");
    }
  };

  const updateColor = (color, isSetBackgound = false) => {
    const root = document.documentElement;
    const { primary, secondary, background } = color;

    if (primary) {
      root.style.setProperty("--primary", `${primary}`);
    }
    if (secondary) {
      root.style.setProperty("--secondary", `${secondary}`);
    }
    if (background && isSetBackgound) {
      root.style.setProperty("--background", `${background}`);
      root.style.setProperty("--settings-overlay-background", `${background}`);
      root.style.setProperty("--dropdown-background", `${background}`);
      root.style.setProperty("--modal-background", `${background}`);
      // if background is set, disable floating background gradients
      root.style.setProperty("--backgroundGradientOpacity", "0.0");
    }
  };

  /**
   * Validates theme query, updates the pinia store with the value used in query, updates the theme.
   * @param {string} queryVal value passed in for 'theme' in the route
   */
  const updateThemeFromQuery = (queryVal) => {
    const globalStore = useGlobalStore();

    if (globalStore.global.theme) {
      // We prioritise saved theme setting over query arguments.
      return;
    }

    const isLightmodeRequest = ["lightmode", "light"].includes(queryVal);
    const theme = isLightmodeRequest ? "LIGHT" : "DARK";
    globalStore.setTheme(theme);

    updateThemeFromStore();
  };

  const updateThemeFromMerchant = (theme) => {
    const globalStore = useGlobalStore();
    // color should always be updated
    updateColor(theme, globalStore.getIsGreyLabel);

    if (globalStore.getIsThemeSetted) {
      // don't override the setting when the theme is set
      return;
    }

    const themeMode = theme?.mode?.toUpperCase() || "DARK";
    globalStore.setTheme(themeMode);
    // Prioritise the local storage before quering the API
    updateTheme(themeMode === "LIGHT");
  };

  return {
    updateThemeFromStore,
    updateThemeFromQuery,
    updateThemeFromMerchant,
  };
};

export default useTheme;
